import { Ass_06, Inc_02, Lia_02 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const OUTGOING_VAT_INVOICE: Template = {
  id: "e3284c46-ad92-4d10-b248-b90fd196d177",
  name: "Müügiarve KM-ga (Eesti)",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Invoice date",
      type: "date"
    },
    {
      name: "Sales amount",
      type: "amount_eur"
    },
    {
      name: "VAT amount",
      type: "amount_eur"
    }
  ],
  generate: (values) => {
    const invoiceDate = findVariableValue("Invoice date", values);

    const salesAmount = Math.round(parseFloat(findVariableValue("Sales amount", values)) * 100);
    const vatAmount = Math.round(parseFloat(findVariableValue("VAT amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Arve summa",
          date: invoiceDate,
          amount: salesAmount,
          eurAmount: salesAmount,
          currency: "eur",
          debit: Ass_06,
          credit: Inc_02
        },
        {
          title: "Käibemaks",
          date: invoiceDate,
          amount: vatAmount,
          eurAmount: vatAmount,
          currency: "eur",
          debit: Ass_06,
          credit: Lia_02
        }
      ]
    };

    return { type: "success", entry };
  }
};
